import script from "./UploadFileImages.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFileImages.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFileImages.vue?vue&type=style&index=0&id=6459ecd6&scoped=true&lang=css"
import "./UploadFileImages.vue?vue&type=style&index=1&id=6459ecd6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6459ecd6"]])

export default __exports__